import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AppDataService, MerchantService, StoreService } from 'app/services';
import { MessageService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationType, MerchantUserRolesEnum } from 'app/models';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, startWith, switchMap } from 'rxjs';
import { MerchantStoreItem } from 'app/merchant/partners-portal/types/merchant-store-item.type';
import { duplicateAddressValidator } from 'app/merchant/partners-portal/validators/duplicate-address.validator';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Utils } from 'app/utils';
import { MatSelectChange } from '@angular/material/select';
import { ComboItemDto } from 'app/merchant/partners-portal/interfaces/combo-item.interface';
import { ActionType } from 'app/models/enums/store-open-close-action-type.enum';

@Component({
  selector: 'partner-mart-locations-details',
  standalone: false,
  templateUrl: './partner-mart-locations-details.component.html',
  styleUrls: ['./partner-mart-locations-details.component.scss',
    '../../../../../../../styles/m3-defaul-material-theme.scss']
})
export class PartnerMartLocationsDetailsComponent implements OnInit{
  @Input() selectedStore: any;
  @Input() merchantId: number = 0;
  @Input() stores: MerchantStoreItem[] = [];
  @Output() hideDetails = new EventEmitter<boolean>();
  loading: boolean = false;
  storeFullData: any;
  isEditMode: boolean = false;
  hasExistingPaymentDetails: boolean = false;
  isLoadingPaymentCheck: boolean = true;
  discardConfirmDialog: boolean = false;
  modeName: string = '';
  locationName: string = '';
  merchantName: string = '';
  editStoreDto: any;
  createStoreForm!: FormGroup;
  currentTabIndex: number = 0;

    //details tab
    isDetailsFirstLoad: boolean = true;
    readonly locationTypeList = LocationType.LocationTypeList;
    // ? Google Maps API variables
    @ViewChild('mapContainer') mapContainer!: ElementRef;
    filteredOptions$?: Observable<google.maps.places.AutocompletePrediction[]>;
    private map: google.maps.Map | undefined;
    private circle: google.maps.Circle | undefined;
    private autocompleteService:
        | google.maps.places.AutocompleteService
        | undefined;
    private placesService: google.maps.places.PlacesService | undefined;
    private geocoder?: google.maps.Geocoder;
    private currentMarker: google.maps.Marker | null = null;
    private lat: number = 0;
    private long: number = 0;

     //settings tab
     merchantsList: ComboItemDto[] = [];
     commissionDisplayValue: string = '';
     promoAdvertisingDisplayValue: string = '';
     amountDisplayValue: string = '';
     feeDisplayValue: string = '';
     public noInternetConnection: boolean = false;

  constructor(
      private fb: FormBuilder,
      private storeService: StoreService,
      private messageService: MessageService,
      private merchantService: MerchantService,
      public appData: AppDataService,
      public cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.checkInternetConnection();
    this.setupNetworkListeners();
      this.createStoreForm = this.fb.group({
          details: this.fb.group({
              Address: ['', Validators.required],
              Radius: [5, Validators.required],
              Brand: ['', Validators.required],
              Name: ['', Validators.required],
              Email: ['', [Validators.required, Validators.email]],
              Phone: ['', [Validators.required, Validators.pattern(/^(09|\+639)\d{9}$/)]],
              City: [''],
              PostalCode: [''],
              LocationTypeId: ['', Validators.required],
              AddressDetails: ['', Validators.required],
              ImageUrl: ['']
          }),
          settings: this.fb.group({
              MerchantId: [0, Validators.required],
              Commission: [0, Validators.required],
              MinimalOrderAmount: [0, Validators.required],
              MinimalOrderFee: [0, Validators.required],
              PromoAdvertisingBudget: [{ value: 'Coming Soon', disabled: true }, Validators.required]
          }),
      });

    this.getStore();
    this.getMerchantsForCombo();
    this.checkExistingPaymentDetails();
   }

  goBack(){
      if (this.isEditMode) {
          if (this.storeFullData.MerchantId !== this.settingsForm.value.MerchantId ||
              this.storeFullData.Commission !== this.settingsForm.value.Commission ||
              this.storeFullData.MinimalOrderAmount !== this.settingsForm.value.MinimalOrderAmount ||
              this.storeFullData.MinimalOrderFee !== this.settingsForm.value.MinimalOrderFee ||
              this.detailsForm.dirty
            ) {
              this.discardConfirmDialog = true;
          } else {
              this.hideDetails.emit(false);
          }
      } else {
          this.hideDetails.emit(false);
      }
  }

  getMerchantId(): number {
    return this.merchantId;
  }

  onTabChange(event: MatTabChangeEvent) {
      this.currentTabIndex = event.index;
      this.isEditMode = false;
      this.modeName = this.isEditMode ? 'Edit ' + event.tab.textLabel : event.tab.textLabel;
  }
  editBtnClick() {
      if (this.isEditMode) {
          switch (this.currentTabIndex) {
            case 2: this.updateDetails(); this.modeName = 'Details'; break;
            case 5: this.updateSettings(); this.modeName = 'Settings'; break;
          }
      } else {
          if (this.currentTabIndex === 2) {
              this.modeName = 'Edit Details';
              this.detailsForm.get('Address')?.valueChanges.subscribe(value => {
                  if (!value?.place_id) {
                      this.detailsForm.get('Address')?.setErrors({ invalidAddress: true });
                  }
              });
              this.detailsForm.get('Radius')?.valueChanges.subscribe(value => {
                  this.updateRadius(value);
              });
              setTimeout(() => {
                  this.setMaps();
              }, 1000);
  }
          else if (this.currentTabIndex === 5) {
              this.modeName = 'Edit Settings';
          }

          this.isEditMode = !this.isEditMode;
      }
  }

  swapEditMode() {
      this.isEditMode = !this.isEditMode;
  }

  getStore() {
    this.loading = true;
    const dto = {
      StoreId: this.selectedStore.Id
    };

    this.storeService.getStore(dto, this.messageService)
        .then(data => {
          if (!data) {
            this.loading = false;
            return;
          }

          if (!data.Success) {
            this.loading = false;
            console.log(data.ErrorMessage);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
            return;
          }

          this.storeFullData = data;
          this.merchantId = data.MerchantId;
          this.merchantName = data.MerchantName;

          this.setLocationName(data);
          this.setDetails(data);
          this.setSettings(data);
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        });
  }

  setLocationName(storeData: any) {
      this.locationName = this.locationTypeList.find(x => x.value === storeData.LocationTypeId)?.name;
  }

  setDetails(data: any) {
    this.detailsForm.get('Address')?.setValue(data.Address, { emitEvent: false });
    this.detailsForm.get('AddressDetails')?.setValue(data.AddressDetails, { emitEvent: false });
    this.detailsForm.get('Brand')?.setValue(data.Brand, { emitEvent: false });
    this.detailsForm.get('Name')?.setValue(data.Name, { emitEvent: false });
    this.detailsForm.get('Email')?.setValue(data.Email, { emitEvent: false });
    this.detailsForm.get('Phone')?.setValue(data.Phone, { emitEvent: false });
    this.detailsForm.get('Lat')?.setValue(data.Lat, { emitEvent: false });
    this.detailsForm.get('Long')?.setValue(data.Long, { emitEvent: false });
    this.detailsForm.get('LocationTypeId')?.setValue(data.LocationTypeId, { emitEvent: false });
    this.detailsForm.get('ImageUrl')?.setValue(data.ImageUrl, { emitEvent: false });
    this.detailsForm.get('City')?.setValue(data.City, { emitEvent: false });
    this.detailsForm.get('PostalCode')?.setValue(data.PostalCode, { emitEvent: false });
  }

  setSettings(data: any) {
      this.settingsForm.get('MerchantId')?.setValue(data.MerchantId, { emitEvent: false });
      this.settingsForm.get('Commission')?.setValue(data.Commission, { emitEvent: false });
      this.settingsForm.get('MinimalOrderAmount')?.setValue(data.MinimalOrderAmount, { emitEvent: false });
      this.settingsForm.get('MinimalOrderFee')?.setValue(data.MinimalOrderFee, { emitEvent: false });
  }

    getMerchantsForCombo(): void {
        const dto = {
            IsLimitedByCurrentUser: true,
        };
        this.merchantService.getMerchantsForCombo(dto, this.messageService)
            .then(data => {
                if (data && data.length > 0) {
                    this.merchantsList = data;
                }
            })
            .catch(err => {
                throw err;
            });
    }

    updateRadius(radius: number) {
        if (this.circle && radius > 0) {
            this.circle.setRadius(radius * 1000);
        }
    }

    private setMaps(): void {
        this.loadGoogleMapsApi().then(() => {
            this.initAutocompleteService();
            this.initMap();
            this.initGeocoder();
            this.filteredOptions$ = this.detailsForm
                .get('Address')
                ?.valueChanges.pipe(
                    startWith(''),
                    switchMap((value) => this.filter(value || ''))
                );
            this.geocodeAddress();
            this.setStreetAddressValidator();

            this.circle = new window.google.maps.Circle({
                map: this.map,
                center: { lat: this.storeFullData.Lat, lng: this.storeFullData.Long },
                radius: (this.createStoreForm.get('Radius')?.value ?? 5) * 1000,
                strokeColor: '#007CFF',
                strokeOpacity: 0.9,
                strokeWeight: 1,
                fillColor: '#007CFF',
                fillOpacity: 0.15
            });
        });
    }

    private filter(
        value: string
    ): Observable<google.maps.places.AutocompletePrediction[]> {
        if (!value) {
            return new Observable((observer) => observer.next([]));
        }
        return new Observable((observer) => {
            this.autocompleteService?.getPlacePredictions(
                { input: value, componentRestrictions: { country: 'PH' } },
                (predictions, status) => {
                    if (
                        status === window.google.maps.places.PlacesServiceStatus.OK &&
                        predictions
                    ) {
                        observer.next(predictions);
                    } else {
                        observer.next([]);
                    }
                }
            );
        });
    }

    private loadGoogleMapsApi(): Promise<void> {
        return new Promise((resolve) => {
            if (window.google && window.google.maps) {
                resolve();
                return;
            }
        });
    }

    private initAutocompleteService(): void {
        this.autocompleteService =
            new window.google.maps.places.AutocompleteService();
        this.placesService = new window.google.maps.places.PlacesService(
            document.createElement('div')
        );
    }

    private initMap(): void {
        this.map = new window.google.maps.Map(this.mapContainer.nativeElement, {
            zoom: 15,
            center: { lat: 14.5995, lng: 120.9842 },
        });
    }

    private initGeocoder(): void {
        this.geocoder = new window.google.maps.Geocoder();
    }

    private geocodeAddress(): void {
        if (!this.storeFullData) {
            return;
        }

        if (!this.geocoder) {
            return;
        }

        this.geocoder.geocode(
            { address: this.storeFullData.Address },
            (results, status) => {
                if (
                    status === window.google.maps.GeocoderStatus.OK &&
                    results &&
                    results.length > 0
                ) {
                    const location = results[0].geometry.location;
                    this.map?.setCenter(location);
                    this.map?.setZoom(13);
                    this.currentMarker = new window.google.maps.Marker({
                        map: this.map,
                        position: location,
                        title: this.storeFullData.Address,
                        draggable: false,
                    });
                    this.addMarkerListener(this.currentMarker);
                } else {
                    // Geocode was not successful
                }
            }
        );
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    onFileDrop(event: DragEvent) {
        event.preventDefault();
        const file = event.dataTransfer?.files[0];
        if (file) {
            this.handleFile(file);
        }
    }

    onImageError(event: any): void {
        this.messageService.add({
            severity: 'warn',
            summary: 'Image Error',
            detail: 'Failed to load the uploaded image. Please try uploading again.',
        });
    }

    get locationPhotoFile(): AbstractControl<File | null, File | null> | null {
        return this.detailsForm.get('ImageUrl');
    }

    onFileSelected(event: Event) {
        const file = (event.target as HTMLInputElement).files?.[0];
        if (file) {
            this.handleFile(file);
        }
    }

    handleFile(file: File) {
        const reader = new FileReader();
        reader.onload = () => {
            this.detailsForm.get('ImageUrl')?.setValue(reader.result);
        };
        reader.readAsDataURL(file);
    }

    removeLocationPhoto(): void {
        this.detailsForm.get('ImageUrl')?.reset();
    }

    displayFn(place: google.maps.places.AutocompletePrediction | string): string {
        if (place) {
            return typeof place === 'string' ? place : place.description;
        }

        return '';
    }

    onOptionSelected(event: MatAutocompleteSelectedEvent): void {
        const selectedPlace = event.option.value;
        if (!this.validateDuplicateAddress(selectedPlace.description)) {
            this.detailsForm.get('Address')?.setValue(selectedPlace);
        }

        this.placesService?.getDetails(
            { placeId: selectedPlace.place_id },
            (place, status) => {
                if (
                    status === window.google.maps.places.PlacesServiceStatus.OK &&
                    place &&
                    place.geometry &&
                    place.geometry.location
                ) {
                    this.map?.setCenter(place.geometry.location);
                    this.map?.setZoom(11);

                    this.lat = place.geometry.location.lat();
                    this.long = place.geometry.location.lng();

                    if (!this.currentMarker) {
                        this.currentMarker = new window.google.maps.Marker({
                            map: this.map,
                            position: place.geometry.location,
                            title: place.name,
                            draggable: false,
                        });
                        this.addMarkerListener(this.currentMarker);
                    } else {
                        this.currentMarker.setPosition(place.geometry.location);
                        this.currentMarker.setTitle(place.name);
                    }

                    if (this.circle) {
                        this.circle.setMap(null);
                    }

                    this.circle = new window.google.maps.Circle({
                        map: this.map,
                        center: place.geometry.location,
                        radius: (this.detailsForm.value.Radius ?? 5) * 1000,
                        strokeColor: '#007CFF',
                        strokeWeight: 1,
                        fillColor: '#007CFF',
                    });
                }
            }
        );
    }

    private addMarkerListener(marker: google.maps.Marker): void {
        marker.addListener('dragend', (event: google.maps.MapMouseEvent) => {
            const newLatLng: google.maps.LatLng | null = event.latLng;
            if (!newLatLng) {
                return;
            }
            const newLat = newLatLng?.lat();
            const newLng = newLatLng?.lng();
            this.reverseGeocode(newLat, newLng);
        });
    }

    private reverseGeocode(lat: number, lng: number): void {
        if (!this.geocoder) {
            return;
        }

        const latlng = { lat, lng };

        this.geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (results && results[0]) {
                    const formattedAddress = results[0].formatted_address;
                    this.detailsForm.get('Address')?.setValue(formattedAddress);
                } else {
                    // No results found for reverse geocoding
                }
            } else {
                // Reverse geocoding failed
            }
        });
    }

    private setStreetAddressValidator(): void {
        this.detailsForm
            .get('Address')
            ?.addValidators(duplicateAddressValidator(this.stores));
    }

    private validateDuplicateAddress(chosenAddress: string): boolean {
        const isDuplicate = this.stores?.some(
            ({ Address }) => Address === chosenAddress
        );

        return isDuplicate;
    }

    get detailsForm(): FormGroup {
        return this.createStoreForm.get('details') as FormGroup;
    }

    get settingsForm(): FormGroup {
        return this.createStoreForm.get('settings') as FormGroup;
    }

    onInput(event: Event) {
        const input = event.target as HTMLInputElement;

        const allowedChars = /[0-9.,]/;
        const inputChar = input.value;

        if (!allowedChars.test(inputChar)) {
            event.preventDefault();
        }
    }

    formatValue(event: Event, field: string = '') {
        const input = event.target as HTMLInputElement;
        let numericValue = input.value.replace(/[^0-9.,]/g, '');
        if (!parseFloat(numericValue)) {
            this.settingsForm.get(field)?.setValue('', { emitEvent: false });
            return;
        }

        numericValue = parseFloat(numericValue).toFixed(2);
        numericValue = numericValue.replace(',', '.');
        this.settingsForm.get(field)?.setValue(numericValue, { emitEvent: false });
        switch (field) {
            case 'Commission': this.setCommissionValue(numericValue); break;
            //case 'PromoAdvertisingBudget': this.promoAdvertisingDisplayValue = numericValue ? `${numericValue}` : ''; break;
            case 'MinimalOrderAmount': this.amountDisplayValue = numericValue ? `${numericValue}` : ''; break;
            case 'MinimalOrderFee': this.feeDisplayValue = numericValue ? `${numericValue}` : ''; break;
        }
    }

    setCommissionValue(numericValue: string) {
        const commission = parseFloat(numericValue);
        if (commission > 100) {
            this.settingsForm.get('Commission')?.setValue(100, { emitEvent: false });
            this.commissionDisplayValue = '100%';
        } else {
            this.commissionDisplayValue = numericValue ? `${numericValue}%` : '';
        }
    }

    updateDetails() {
        this.editStoreDto = {
            Id: this.storeFullData.Id,
            MerchantId: this.storeFullData.MerchantId,
            Address: Utils.isNullOrEmpty(this.detailsForm.value.Address.description)
                ? this.detailsForm.value.Address
                : this.detailsForm.value.Address.description,
            AddressDetails: this.detailsForm.value.AddressDetails,
            ServiceableAreaRadius: this.detailsForm.value.Radius,
            Brand: this.detailsForm.value.Brand,
            Name: this.detailsForm.value.Name,
            Email: this.detailsForm.value.Email,
            Phone: this.detailsForm.value.Phone,
            Lat: this.lat,
            Long: this.long,
            LocationTypeId: parseInt(this.detailsForm.value.LocationTypeId, 10) || 0,
            ImageUrl: this.detailsForm.value.ImageUrl,
            City: this.detailsForm.value.City,
            PostalCode: this.detailsForm.value.PostalCode,
            TimeZoneOffSet: new Date().getTimezoneOffset(),
        };

        this.updateStore(this.editStoreDto);
    }

    updateSettings() {
        this.editStoreDto = {
            Id: this.storeFullData.Id,
            MerchantId: this.storeFullData.MerchantId,
            NewMerchantId: this.settingsForm.value.MerchantId,
            Commission: this.settingsForm.value.Commission,
            PromoAdvertisingBudget: this.settingsForm.value.PromoAdvertisingBudget === 'Coming Soon' ? 0 : this.settingsForm.value.PromoAdvertisingBudget,
            MinimalOrderAmount: this.settingsForm.value.MinimalOrderAmount,
            MinimalOrderFee: this.settingsForm.value.MinimalOrderFee,
            TimeZoneOffSet: new Date().getTimezoneOffset(),
        };

        this.updateStore(this.editStoreDto);
    }

    updateStore(editStoreDto: any) {
        this.loading = true;

        this.storeService.updateStore(editStoreDto, this.messageService)
            .then((data) => {
                if (!data) {
                    this.loading = false;
                    return;
                }

                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: data.ErrorMessage || 'Unable to update store. Please try again.',
                    });
                    return;
                }

                this.storeFullData = data;
                this.selectedStore = {
                    City: this.storeFullData.City,
                    Name: this.storeFullData.Name
                };
                this.merchantName = data.MerchantName;
                this.setLocationName(data);
                this.swapEditMode();

                this.loading = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Store updated successfully!',
                });
            })
            .catch((error) => {
                this.loading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message || 'Unable to update store. Please try again.',
                });
                throw error;
            });
    }

    public cancelDiscard() {
        this.discardConfirmDialog = false;
    }

    public discardConfirm() {
        this.hideDetails.emit(false);
        this.discardConfirmDialog = false;
    }

    protected readonly MerchantUserRolesEnum = MerchantUserRolesEnum;

    onStoreStatusChange(event: boolean) {
        this.loading = true;
        const dto = {
            StoreId: this.storeFullData.Id,
            IsClosed: event,
            ActionType: ActionType.Manual
        };
        this.merchantService.setClosed(dto, this.messageService)
        .then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                console.log(data.ErrorMessage);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }

            this.selectedStore.StatusName = data.IsClosed ? 'Closed' : 'Open';
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Store status updated successfully.' });
            this.loading = false;
        })
        .catch(error => {
            this.loading = false;
            console.log(error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        });
    }

  public checkExistingPaymentDetails() {
    if (!this.merchantId) {
      this.isLoadingPaymentCheck = false;
      return;
    }

    this.isLoadingPaymentCheck = true;
    const payload = {
      MerchantId: this.merchantId
    };

    this.merchantService.getMerchantPayoutAccounts(payload, this.messageService)
      .then((data: any) => {
        this.hasExistingPaymentDetails = data?.Success && data?.Items && data.Items.length > 0;
        this.isLoadingPaymentCheck = false;
      })
      .catch((error: any) => {
        console.error('Error checking payment details:', error);
        this.hasExistingPaymentDetails = false;
        this.isLoadingPaymentCheck = false;
      });
  }

  public refreshPaymentCheck() {
    this.checkExistingPaymentDetails();
  }

  setPublishedStatus(status: boolean): void {
    this.loading = true;
    const dto = {
        StoreId: this.selectedStore.Id,
        IsPublished: status,
    };
    this.storeService.updateStorePublishedStatus(dto, this.messageService)
        .then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                this.loading = false;
                return;
            }

            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Published status successfully updated.' });
            this.selectedStore.PublishedStatus = status ? 'Active' : 'Inactive';
            this.loading = false;
        })
        .catch(error => {
            console.error('Error:', error);
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update published status.' });
            this.loading = false;
            throw error;
        });
    }

    public checkInternetConnection(): void {
        this.noInternetConnection = !navigator.onLine;
    }

    public isActionDisabled(): boolean {
        return this.noInternetConnection;
    }

    private setupNetworkListeners(): void {
        window.addEventListener('online', () => {
        this.noInternetConnection = false;
        this.cdr.detectChanges();
        // Retry loading products when connection is restored
        this.checkExistingPaymentDetails();
        });

        window.addEventListener('offline', () => {
        this.noInternetConnection = true;
        this.cdr.detectChanges();
        });
    }

    private handleNetworkError(err: any): void {
        // Check if it's a network error
        if (err.name === 'NetworkError' ||
            err.message?.includes('Network') ||
            err.message?.includes('fetch') ||
            !navigator.onLine) {
        this.noInternetConnection = true;
        this.cdr.detectChanges();
        } else {
        // Show regular error message for non-network errors
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err,
        });
        }
    }
}
